import request from "@/utils/http"

/**
 * @param userIds []
 * @param roleId
 * @param appId
 * @returns {*}
 */
export function addUsersToApp(userIds, roleIds, appId) {
  return request
    .post(`/users/addUsersToApp`, { userIds, roleIds }, { params: { appId } })
    .commonDeal()
}

/**
 * 移除用户
 * @param userId
 * @param appId
 * @returns {*}
 */
export function removeAppUser(userId, appId) {
  return request.post(`/users/removeAppUser`, null, { params: { userId, appId } }).commonDeal()
}

export function editUserRole(userId, roleIds, appId) {
  return request.post(`/users/editUserRole`, roleIds, { params: { userId, appId } }).commonDeal()
}
